import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { LEVEL_ENTRY, LEVEL_MID, LEVEL_TOP } from './consts';

export const DesignerLevel = PropTypes.oneOf([LEVEL_ENTRY, LEVEL_MID, LEVEL_TOP]);

export const FilterType = PropTypes.oneOf(['checkbox', 'radio']);

export const FilterOption = PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
});

export const GroupedFilterOption = PropTypes.shape({
    parentOption: FilterOption,
    childOptions: PropTypes.arrayOf(FilterOption),
});

export const FilterGroup = PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.oneOfType([
        MobxPropTypes.observableArray,
        PropTypes.arrayOf(FilterOption),
        PropTypes.arrayOf(GroupedFilterOption),
    ]).isRequired,
});

export const Urls = PropTypes.shape({
    urls: PropTypes.shape({
        designersXhr: PropTypes.string.isRequired,
        rootPath: PropTypes.string.isRequired,
    }),
});

export const Pagination = PropTypes.shape({
    currentPage: PropTypes.number,
    totalPages: PropTypes.number,
});

export const imageSources = PropTypes.shape({
    imageSrc: PropTypes.string,
    imageSrcLarge: PropTypes.string.isRequired,
    imageSrcLargeWebp: PropTypes.string.isRequired,
    imageSrcSet2x: PropTypes.string,
    webpSrcSet: PropTypes.string,
    webpSrcSet2x: PropTypes.string,
});

export const Designer = PropTypes.shape({
    name: PropTypes.string.isRequired,
    level: DesignerLevel.isRequired,
    isFavorite: PropTypes.bool,
    canFavorite: PropTypes.bool.isRequired,
    isContact: PropTypes.bool.isRequired,
    review: PropTypes.shape({
        rating: PropTypes.number,
        count: PropTypes.number,
    }).isRequired,
    avatarSrc: PropTypes.string.isRequired,
    isOnline: PropTypes.bool.isRequired,
    expertiseCategories: PropTypes.array.isRequired,
});

export const Designers = PropTypes.arrayOf(
    PropTypes.shape({
        avatarSrc: PropTypes.string,
        name: PropTypes.string,
        id: PropTypes.number,
        urls: PropTypes.shape({
            favoriteUrl: PropTypes.string,
            inviteUrl: PropTypes.string,
            profileUrl: PropTypes.string,
        }),
        isOnline: PropTypes.boolean,
        designs: PropTypes.arrayOf(
            PropTypes.shape({
                designUrl: PropTypes.string,
                id: PropTypes.number,
                srcSet: PropTypes.string,
                title: PropTypes.string,
                description: PropTypes.string,
                imageSources,
            })
        ),
        level: PropTypes.string,
        expertiseCategories: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
            })
        ),
        review: PropTypes.shape({
            rating: PropTypes.number,
            count: PropTypes.number,
        }),
        isFavorite: PropTypes.bool,
        isContact: PropTypes.bool,
        canFavorite: PropTypes.bool.isRequired,
    })
);



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/propTypes.js